export enum AutomationDocsApplyTypes {
  EXISTING = 'EXISTING_DOCS',
  FUTURE = 'FUTURE_DOCS',
}
